import React from "react";

export default function LoadingData() {
    return (<div>loading data...</div>)
}